export default __webpack_public_path__ + "static/Logo_white-211b7d6be2daf862610a702b79eef208.png";